import { Fragment } from 'react'

import { ComposeProviders } from './providers'

function App() {
  return (
    <Fragment>
      <ComposeProviders />
    </Fragment>
  )
}

export default App
